import { render, staticRenderFns } from "./AlertChips.vue?vue&type=template&id=a082ecd8&scoped=true&"
import script from "./AlertChips.vue?vue&type=script&lang=ts&"
export * from "./AlertChips.vue?vue&type=script&lang=ts&"
import style0 from "./AlertChips.vue?vue&type=style&index=0&id=a082ecd8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.10.1_css-loader@6.7.3_vue-template-compiler@2.7.15_webpack@5.80.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a082ecd8",
  null
  
)

export default component.exports